import { useQuery } from '@tanstack/react-query';
import { usePrivy } from '@privy-io/react-auth';
import { fetchParticipantProfile } from '@/lib/api';
import { useAuthStore } from '@/store/authStore';
import type { ParticipantProfile } from '@/lib/types';

export function useParticipantProfile() {
  const { getAccessToken } = usePrivy();
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  return useQuery<ParticipantProfile>({
    queryKey: ['participantProfile'],
    queryFn: async () => {
      const token = await getAccessToken();
      if (!token) throw new Error('No Privy session');
      return fetchParticipantProfile(token);
    },
    staleTime: 30_000,
    enabled: isAuthenticated,
  });
}
